import { modalRenderer } from '~/modal/modalRendererRegistry';
import { PublicMapColumnsDisplaySettingsContainer } from './publicMapColumnsDisplaySettings.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    PublicMapColumnsDisplaySettings: undefined;
  }
}

modalRenderer.register('PublicMapColumnsDisplaySettings', PublicMapColumnsDisplaySettingsContainer);
